import { render } from "./Projects.vue?vue&type=template&id=c05c298c&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=c05c298c&lang=scss&scoped=true"
import "./Projects.vue?vue&type=style&index=1&id=c05c298c&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05c298c"]])

export default __exports__